<div
  class="w-[24px] rounded-full border-none select-none flex justify-center items-center font-sans"
  [class]="
    job_badge
      ? 'bg-G200 text-G800 h-[16px] px-[6px] py-1'
      : 'bg-C500 text-white h-[24px]'
  "
>
  <div [class]="job_badge ? 'text-b2' : 'text-b2'">
    {{ value }}
  </div>
</div>
